import { render } from "./ElectronicaConfig.vue?vue&type=template&id=41c7a7f4"
import script from "./ElectronicaConfig.vue?vue&type=script&lang=js"
export * from "./ElectronicaConfig.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__